import React, { useState } from "react";
import "./DettagliRinnovo.scss";
import Header from "../../components/Header";
import { DateTime } from "luxon";
import { useSelector } from "react-redux";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';
import NewHeader from "../../components/New Header/NewHeader";

function DettagliRinnovo() {
  const [navigation, setNavigation] = useState(true);
  const [overlay, setOverlay] = useState(false);
  const navigate = useNavigate()
  const saldoPositivo = useSelector(
    (user) => user.user.nuoviDatiContratto.mono_positivo
  );
  const saldoNegativo = useSelector(
    (user) => user.user.nuoviDatiContratto.mono_negativo
  );
  const opzioneTariffaria = useSelector(
    (user) => user.user.info.opzione_tariffaria
  );
  const quotaFissaPos = useSelector(
    (user) => user.user.nuoviDatiContratto.qf_positivo
  );
  const quotaFissaNeg = useSelector(
    (user) => user.user.nuoviDatiContratto.qf_negativo
  );
  const punDaily = useSelector((user) => user.user.info.pun_oggi);
  return (
    <div className="dettagliRinnovo">
      <div className="dettagliRinnovo-top">
        <NewHeader title="Dettagli Rinnovo" iconsColor="white" />
      </div>
      <div className="dettagliRinnovo-bottom">
        <p className="info">
          L’offerta prevede il prezzo variabile aggiornato mensilmente e che
          resterà valido per tutta la durata della fornitura, secondo la
          formula:
          <br />
          <br />{" "}
          <span className="bold">
            {" "}
            Prezzo al kWh tutto incluso = Prezzo PUN + Spread
          </span>
        </p>
        <div className="priceBox">
          <p className="label">Prezzo</p>
          <p className="sulLabel">Applicato in base al saldo giornaliero</p>
          <div className="group">
            <div className="negativo">
              <p className="type">Negativo</p>
              <p className="type">PUN + SPREAD</p>
              <p className="price">
                {parseFloat(saldoNegativo).toFixed(2).replace(/\./g, ",")}
                <span> €/kWh *</span>
              </p>
              {opzioneTariffaria && opzioneTariffaria !== "D2" ? (
                <p className="quotaFissa">
                  +{parseFloat(quotaFissaNeg).toFixed(2).replace(/\./g, ",")}€
                  al giorno
                </p>
              ) : null}
              {opzioneTariffaria &&
              opzioneTariffaria !== "D2" &&
              opzioneTariffaria !== "D3" ? (
                <p className="iva">IVA da aggiungere</p>
              ) : null}
            </div>
            <div className="positivo">
              <p className="type">Positivo</p>
              <p className="type">PUN + SPREAD</p>
              <p className="price">
                {parseFloat(saldoPositivo).toFixed(2).replace(/\./g, ",")}
                <span> €/kWh *</span>
              </p>
              {opzioneTariffaria && opzioneTariffaria !== "D2" ? (
                <p className="quotaFissa">
                  +{parseFloat(quotaFissaPos).toFixed(2).replace(/\./g, ",")}€
                  al giorno
                </p>
              ) : null}
              {opzioneTariffaria &&
              opzioneTariffaria !== "D2" &&
              opzioneTariffaria !== "D3" ? (
                <p className="iva">IVA da aggiungere</p>
              ) : null}
            </div>
          </div>
          <p className="plus">
            * Prezzo calcolato su PUN aggiornato al{" "}
            {DateTime.now().toFormat("dd/MM/y")} di{" "}
            {parseFloat(punDaily).toFixed(4).replace(/\./g, ",")} €/kWh.
            <br /> <br />
            Il Prezzo Unico Nazionale (PUN) è il prezzo della materia prima
            elettrica sul mercato all’ingrosso ed è il valore di riferimento per
            il calcolo del prezzo finale che vedi sulla bolletta della luce. Il
            PUN varia di giorno in giorno e Revoluce lo prende in considerazione
            per ridefinire le tariffe della luce di mese in mese per le offerte
            a prezzo indicizzato.
            <br />
            <br />
            <a
              href="https://www.mercatoelettrico.org/It/Tools/Accessodati.aspx?ReturnUrl=%2fit%2fStatistiche%2fME%2fDatiSintesi.aspx"
              target="_blank"
            >
              Tutti i valori sono pubblicati sul sito del Gestore dei Mercati
              Energeti
            </a>
          </p>
        </div>
        <div className="help">
          <div className="item" onClick={() => window.open('https://revolucionari.it/aumenti-e-guerra/')}>
            <p>Scopri di più</p>
            <ArrowForwardIosIcon />
          </div>
          <div
            className="item"
            onClick={() => navigate('/enrica/promo')}
          >
            <p>Risparmia con Ricarica 3-6-12</p>
            <ArrowForwardIosIcon />
          </div>
          <div
            className="item"
            onClick={() => window.open('https://my.revoluce.it/uploads/doc/kit_contrattuale_web.pdf')}
          >
            <p>Scarica il Kit Contrattuale</p>
            <ArrowForwardIosIcon />
          </div>
        </div>
        <div className="emptyBox" style={{height: '100px'}} />
      </div>
    </div>
  );
}

export default DettagliRinnovo;
